import { useMutation } from 'hooks/useMutation'
import { useQueryClient } from 'hooks/useQueryClient'

import {
  addPendingMembershipForUserId,
  cancelPendingMembershipByUserIdAndProgramId,
  fetchGroupById,
} from 'utils/queries'

import { Program } from 'types/program'
import { UserType } from 'types/user'

export const usePendingMembership = ({
  userId,
  programId,
  program,
  trainer,
}: {
  userId?: string
  programId?: string
  program?: Program
  trainer?: UserType
}) => {
  const queryClient = useQueryClient()

  const addPendingMembership = useMutation(
    async () => {
      if (!userId || (!programId && (!program || !trainer))) {
        throw new Error('Error adding pending membership')
      }

      let programWithTrainer = program
      if (program) {
        programWithTrainer.trainer = trainer
      } else {
        programWithTrainer = await fetchGroupById(programId)
      }

      await addPendingMembershipForUserId(userId as string, programWithTrainer as Program)
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['pendingMemberships'])
      },
    },
  )

  const cancelPendingMembership = useMutation(
    async () => {
      if (!userId || !programId) throw new Error('Error deleting pending membership')
      await cancelPendingMembershipByUserIdAndProgramId(userId as string, programId as string)
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['pendingMemberships'])
      },
    },
  )

  return {
    addPendingMembership,
    cancelPendingMembership,
  }
}
